import { css, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { ContentSection } from './ContentSection'
import { PersonBooks } from './PersonBooks'

interface Props {
  name: string
  books?: Book[]
  biography: React.ReactNode
}

export const PersonInfo = ({ books, biography, name }: Props) => {
  const { mediaQueries } = useTheme()

  return (
    <div
      className={css`
        padding: 0 16px 100px;
        ${mediaQueries.mobileL} {
          padding: 0;
          padding-bottom: 32px;
        }
        ${mediaQueries.tabletL} {
          width: 50%;
          overflow-y: auto;
        }
      `}
    >
      <ContentSection label="Bio">{biography}</ContentSection>
      {!!books?.length ? (
        <ContentSection label={`${name} Books`}>
          <PersonBooks books={books} />
        </ContentSection>
      ) : null}
    </div>
  )
}
